import Request from '../baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const getConfig = () => {
  const token = getUserToken()
  return {
    headers: {
      authorization: `Bearer ${token}`
    }
  }
}

const baseUrl = programId => `${window.config.VUE_APP_BACKEND}/api/loyalty-programs/${programId}`

// Arma el query string con los parámetros que tienen valor.
const toQuery = params => {
  const parts = []
  Object.keys(params || {}).forEach(key => {
    const value = params[key]
    if (value === undefined || value === null || value === '') return
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
  })
  return parts.length ? `?${parts.join('&')}` : ''
}

const _getMembers = ({ programId, skip, limit, q, sort }) => {
  return Request.get(`${baseUrl(programId)}/members${toQuery({ skip, limit, q, sort })}`, getConfig())
}

const _getMember = ({ programId, customerKey, skip, limit }) => {
  return Request.get(`${baseUrl(programId)}/members/${encodeURIComponent(customerKey)}${toQuery({ skip, limit })}`, getConfig())
}

const _getTransactions = ({ programId, skip, limit, type, customer_email, order_id, from, to }) => {
  return Request.get(`${baseUrl(programId)}/transactions${toQuery({ skip, limit, type, customer_email, order_id, from, to })}`, getConfig())
}

const _getSummary = ({ programId, from, to }) => {
  return Request.get(`${baseUrl(programId)}/summary${toQuery({ from, to })}`, getConfig())
}

const _createAdjustment = ({ programId, payload }) => {
  return Request.post(`${baseUrl(programId)}/adjustments`, payload, getConfig())
}

const _simulate = ({ programId, payload }) => {
  return Request.post(`${baseUrl(programId)}/simulate`, payload, getConfig())
}

// Recompensas del programa (definición) y sus números en el motor.
const rewardsUrl = () => `${window.config.VUE_APP_BACKEND}/api/loyalty-rewards`

const _getRewards = ({ programId }) => {
  return Request.get(`${rewardsUrl()}?where[loyaltyProgram]=${encodeURIComponent(programId)}&limit=100`, getConfig())
}

const _createReward = payload => {
  return Request.post(rewardsUrl(), payload, getConfig())
}

const _updateReward = payload => {
  return Request.put(`${rewardsUrl()}/${payload._id}`, payload, getConfig())
}

const _deleteReward = rewardId => {
  return Request.delete(`${rewardsUrl()}/${rewardId}`, getConfig())
}

const _getRewardStats = ({ programId }) => {
  return Request.get(`${baseUrl(programId)}/rewards`, getConfig())
}

const _grantReward = ({ programId, rewardId, payload }) => {
  return Request.post(`${baseUrl(programId)}/rewards/${encodeURIComponent(rewardId)}/grant`, payload, getConfig())
}

const _claimReward = ({ programId, rewardId, payload }) => {
  return Request.post(`${baseUrl(programId)}/rewards/${encodeURIComponent(rewardId)}/claim`, payload, getConfig())
}

const _getVouchers = ({ programId, skip, limit, status, reward_id, customer_email, q }) => {
  return Request.get(`${baseUrl(programId)}/vouchers${toQuery({ skip, limit, status, reward_id, customer_email, q })}`, getConfig())
}

const _cancelVoucher = ({ programId, code, payload }) => {
  return Request.post(`${baseUrl(programId)}/vouchers/${encodeURIComponent(code)}/cancel`, payload || {}, getConfig())
}

export default {
  getRewards: _getRewards,
  createReward: _createReward,
  updateReward: _updateReward,
  deleteReward: _deleteReward,
  getRewardStats: _getRewardStats,
  grantReward: _grantReward,
  claimReward: _claimReward,
  getVouchers: _getVouchers,
  cancelVoucher: _cancelVoucher,
  getMembers: _getMembers,
  getMember: _getMember,
  getTransactions: _getTransactions,
  getSummary: _getSummary,
  createAdjustment: _createAdjustment,
  simulate: _simulate
}
